@if (previewList && previewList.length > 0) {
  <div class="preview-container">
    <div class="image-preview-fullscreen">
      @if (currentFileUrl) {
        <div class="file-viewer">
          @if (isImage(currentFileName)) {
            <img [src]="currentFileUrl" alt="{{ currentFileName }}" />
          }
          @if (isPdf(currentFileName)) {
            <iframe [src]="currentFileUrl | safeUrl" frameborder="0"></iframe>
          }
          @if (isText(currentFileName)) {
            <pre>
              {{ currentTextContent }}
            </pre>
          }
        </div>
      } @else {
        <p>Loading preview...</p>
      }
      <div class="nav-buttons">
        <div class="file-name-container">
          @if (!this.userService.roleCheck(['Labtech'])) {
            <button
              mat-icon-button
              (click)="downloadCurrentFile()"
              aria-label="Download"
              class="download-btn"
              >
              <mat-icon>download</mat-icon>
            </button>
          }
          <span class="file-name">{{ currentFileName }}</span>
        </div>
        <div class="nav-center">
          <button
            (click)="prevFile()"
            [disabled]="currentIndex === 0"
            aria-label="Previous Image"
            >
            <span class="nav-label">Previous</span><mat-icon>chevron_left</mat-icon>
          </button>
          <button
            (click)="nextFile()"
            [disabled]="currentIndex === previewList.length - 1"
            aria-label="Next Image"
            >
            <mat-icon>chevron_right</mat-icon><span class="nav-label">Next</span>
          </button>
        </div>
      </div>
    </div>
  </div>
} @else {
  <p>No files available for preview.</p>
}

